module.exports = __webpack_public_path__ + "static/logo-absolu-sens-dc5ca651c19e8d0243b20bf9226c8817.png";